import { render, staticRenderFns } from "./Simplechart.vue?vue&type=template&id=24fa7908"
import script from "./Simplechart.vue?vue&type=script&lang=js"
export * from "./Simplechart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports